import { postAuthLogin } from "apis/auth";
import { json, Params, redirect } from "react-router-dom";

const SigninLoader = async ({ params }: { params: Params<string> }) => {
  try {
    if (!params) throw new Error();

    const authCode = new URL(window.location.href).searchParams.get("code");
    if (!authCode) throw new Error();

    const data = await postAuthLogin({
      provider: (params.provider as "kakao" | "google") || "goggle",
      code: authCode,
    });

    if (data) {
      return json(data, { status: 200 });
    }

    throw new Error();
  } catch (e) {
    alert("문제가 발생했습니다. 다시 로그인해주세요.");
    return redirect("/data-room");
  }
};

export default SigninLoader;
